import { theme } from '@arnold/common';
import styled from '@emotion/styled';
import { forwardRef } from 'react';
import { NavbarFilter, NavbarFilterProps } from './NavbarFilter';

type MobileFiltersProps = Pick<NavbarFilterProps, 'pillNumber' | 'setShowFilters' | 'addedOnFrom' | 'addedOnTo'> & {
  isInSequence?: boolean;
};

export const MobileFilters = forwardRef<HTMLDivElement, MobileFiltersProps>(
  ({ setShowFilters, pillNumber, isInSequence, addedOnFrom, addedOnTo }, ref) => {
    return (
      <MobileFiltersWrapper ref={ref} isInSequence={isInSequence}>
        <NavbarFilter
          title=""
          setShowFilters={setShowFilters}
          showFilters={false}
          pillNumber={pillNumber}
          addedOnFrom={addedOnFrom}
          addedOnTo={addedOnTo}
        />
      </MobileFiltersWrapper>
    );
  },
);

const MobileFiltersWrapper = styled.div<{ isInSequence?: boolean }>`
  background-color: ${theme.background.primary};
  margin: 0px -${theme.spacing.f} 0px -${theme.spacing.f};
  padding-bottom: ${theme.spacing.d};
  display: flex;
  justify-content: center;

  ${({ isInSequence }) =>
    isInSequence &&
    `margin-top: -${theme.spacing.j};
    margin-bottom: ${theme.spacing.j};
  `}
`;
